import { render, staticRenderFns } from "./ConfirmationView.vue?vue&type=template&id=37beefe5&scoped=true&"
import script from "./ConfirmationView.vue?vue&type=script&lang=js&"
export * from "./ConfirmationView.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationView.vue?vue&type=style&index=0&id=37beefe5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37beefe5",
  null
  
)

export default component.exports